import './event-tracking';

var ua = navigator.userAgent.toLowerCase();
var isBrowser = true;
var isToutiao = false;

if (ua.match(/MicroMessenger/i) == "micromessenger" ||
    ua.match(/WeiBo/i) == "weibo" ||
    ua.match(/QQ/i) == "qq" ||
    ua.includes('newsarticle') ) { // toutiao
      isBrowser = false;

      if (ua.includes('newsarticle')) {
        isToutiao = true;
      }
}

let calendarButtons = document.querySelectorAll('.calendar');
let calendarTip = document.querySelector('.instruction-tip');

if (isToutiao) {
  calendarTip.style.display = 'none';
}

calendarButtons.forEach(button => {

  if (!isBrowser) {
    button.href = "javascript: void(0)";
  }

  if (isToutiao) {
    button.style.display = "none";
  } else {

    button.addEventListener('click', (e) => {
      if (!isBrowser) {
        
        document.body.classList.add('instruction-shown');
      }
    })
  }

});

let closeButton = document.getElementById('instruction-close');
closeButton.addEventListener('click', () => {
  document.body.classList.remove('instruction-shown');
});

